import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';

export default function Historyc() {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    LineElement,
    Title,
    Tooltip,
    PointElement,
    Legend,
    ChartDataLabels
  );
  const labels = [1, 2, 3, 4, 5, 6, 7];

  const data = {
    labels: labels,
    datasets: [{
      label: 'My First Dataset',
      data: [65, 59, 80, 81, 56, 55, 40],
      fill: false,
      borderColor: 'rgb(75, 192, 192)',
      tension: 0.1
    }]
  };


  return (
    <>
      <div style={{ padding: '15px 10px', height: '50%', background: '#fff', borderRadius: '8px' }}>
        <Line options={{
          responsive: true,
          maintainAspectRatio: false,
        }} data={data} />
      </div>
      <section style={{ height: '40px', display: 'flex', alignItems: 'center', gap: '10px', padding: '0px 5px', marginTop: '5px', width: '100%', borderRadius: '8px' }}>
        <div style={{ height: '80%', borderRadius: '8px', width: '70px', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#fff', position: 'relative' }}>Filtro um <section style={{ position: 'absolute', top: '-5px', right: '-5px', width: '15px', height: '15px', background: '#ccc', borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>X</section></div>
        <div style={{ height: '80%', borderRadius: '8px', width: '70px', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#fff', position: 'relative' }}>Filtro dois<section style={{ position: 'absolute', top: '-5px', right: '-5px', width: '15px', height: '15px', background: '#ccc', borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>X</section></div>
        <div style={{ height: '80%', borderRadius: '8px', width: '70px', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#fff', position: 'relative' }}>Filtro tres<section style={{ position: 'absolute', top: '-5px', right: '-5px', width: '15px', height: '15px', background: '#ccc', borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>X</section></div>
      </section>

      <section style={{ display: 'flex', marginTop: '5px', width: '100%', gap: '20px' }}>
        <section style={{ background: '#fff', height: '250px', width: '150px', borderRadius: '10px' }}>
          <table>
            <thead>
              <tr>
                <th>Qtd Pessoas</th>
                <th>Evento</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>15</td>
                <td>1</td>
              </tr>
              <tr>
                <td>15</td>
                <td>1</td>
              </tr>
              <tr>
                <td>15</td>
                <td>1</td>
              </tr>
              <tr>
                <td>15</td>
                <td>1</td>
              </tr>
            </tbody>
          </table>
        </section>
        <section style={{ background: '#fff', height: '250px', width: '100%', maxWidth: '600px', borderRadius: '10px', display: 'flex', alignSelf: 'flex-end' }}>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Evento</th>
                <th>Qtd Pessoas</th>
                <th>Sede</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>1</td>
                <td>1</td>
              </tr>
              <tr>
                <td>1</td>
                <td>1</td>
                <td>1</td>
              </tr>
            </tbody>
          </table>
        </section>
      </section>

      <section style={{ display: 'flex', marginTop: '10px', width: '100%', gap: '20px' }}>
        <section style={{ backgroundColor: '#fff', display: 'flex', alignItems: 'center', height: '110px', width: '25%', borderRadius: '5px' }}>
          <div style={{ borderRight: '1px solid #ccc', width: '30%', height: '80%' }}>

          </div>
          <div></div>
        </section>
        <section style={{ backgroundColor: '#fff', display: 'flex', alignItems: 'center', height: '110px', width: '25%', borderRadius: '5px' }}>
          <div style={{ borderRight: '1px solid #ccc', width: '30%', height: '80%' }}>

          </div>
          <div></div>
        </section >
        <section style={{ backgroundColor: '#fff',display: 'flex', alignItems: 'center', height: '110px', width: '25%', borderRadius: '5px' }}>
          <div style={{ borderRight: '1px solid #ccc', width: '30%', height: '80%' }}>

          </div>
          <div></div>
        </section>
        <section style={{ backgroundColor: '#fff',display: 'flex', alignItems: 'center', height: '110px', width: '25%', borderRadius: '5px' }}>
          <div style={{ borderRight: '1px solid #ccc', width: '30%', height: '80%' }}>

          </div>
          <div></div>
        </section>
      </section>


    </>
  )
}
